import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const SpinnerClassName = CLASS_NAME_PREFIX + "-spinner";
export const SpinnerIconClassName = SpinnerClassName + "__icon";
